export default "__VITE_ASSET__CR70g1FS__"